import React, { Component } from "react";
import { connect } from "react-redux";
import { buildUrlFromParams } from "../../common/functions/url";
import { takeExcelFile } from "../../common/functions/excelExport";
import WithAjax from "../../common/helpers/WithAjax";
import { setJumbotronTitle } from "../../../actions/common";
import SkillVendorSearch from "./SkillVendorSearch";
import SkillVendorList from "./SkillVendorList";
import NewAdminMessageButton from "../../admin-messages/list/components/NewAdminMessageButton/NewAdminMessageButton";
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import Alert from '../../../ui-elements/alerts/Alert'
import {getCountryDBcode} from '../../../panel-admin/common/functions/countrySetting'
import {
  validateSkillVendorSearchField,
  setSkillVendorSearchDropdownOptions,
  setSkillVendorSearchCheckboxValue,
  clearSkillVendorSearchFields
} from '../../../actions/pages/skillvendor-page'



class SkillVendorSearchAndList extends Component {
  constructor() {
    super();
    this.onSearch = this.onSearch.bind(this);
    this.exportSkillVendors = this.exportSkillVendors.bind(this);
    this.inputSearch = this.inputSearch.bind(this);


    this.timeout = 0
    this.directorSchools = [];
    this.editorSchools = [];
    this.singerSchools = [];
    this.soundEngineerSchools = [];
    this.voiceActorSchools = [];

    this.textInput = React.createRef();


    this.state = {
      schoolsArr:[],
      schools: [],
      items: [],
      dataSearch: '',
      iputSearch: '',
      personalCounter: '',
      directorCounter:'',
      translatorCounter:'',
      adaptorCounter:'',
      lyricistCounter:'',
      actorCounter:'',
      singerCounter:'',
      editorCounter:'',
      soundEngineerCounter:'',
      bookerCounter:'',
      castCounter:'',
      showSaveTalentOptions: false,
      selectedSaveFilterOption: '',
      checkedFilters:null,
      filterList:null,
      filterModal:false,
      filterListName:'',
      itemsForFilter:[],
      fullTextSearchForFilter: '',
      filterListModal:false,
      selectedFilterListName:'',
      selectedFilterList:'',
      selectedFilterListId:'',
      filterListNameError:null,
      isListSelected:false
    };
  }

  countSelectedFilters(items, profileTypeNumberTwoFirstNumbers){
     let profileTypeItemsArr = items.filter((item) => item.SearchProperty.toString().length>2);
     let counterArr = [];
     profileTypeItemsArr.map((element) =>{
       let str = element.SearchProperty.toString();
       if(str.substring(0,2) == profileTypeNumberTwoFirstNumbers){
           counterArr.push(element.SearchProperty);
       }
     });
     return  counterArr.length;
   }

  componentDidMount() {
    this.props.setJumbotronTitle("Talents");
    this.textInput.current.focus();
  }

  onSearch() {
    var searchTextValue = this.getFieldValue("SearchText");
    var skillTypeFieldValue = this.getFieldValue("SkillType");
    var ageFromFieldValue = this.getFieldValue("AgeFrom");
    var ageToFieldValue = this.getFieldValue("AgeTo");
    var skillLevelFieldValue = this.getFieldValue("SkillLevel");
    var cityFieldValue = this.getFieldValue("City");
    var nativeLanguageFieldValue = this.getFieldValue("NativeLanguage");
    var experienceFieldValue = this.getFieldValue("Experience");
    var productionFieldValue = this.getFieldValue("Production");
    var vacancyFieldValue = this.getFieldValue("Vacancy");
    var externalExperienceFieldValue = this.getFieldValue("ExternalExperience");
    var skillVendorStatusFieldValue = this.getFieldValue("SkillVendorStatus");

    var doNotUseFieldValue = this.getFieldValue("DoNotUse");

    var countryFieldValue = this.getFieldValue("CountryofLiving");
    var ethnicityFieldValue = this.getFieldValue("Ethnicity");
    var identityFieldValue = this.getFieldValue("Identity");
    var knownTalentFieldValue = this.getFieldValue("KnownTalent");
    var regionFieldValue = this.getFieldValue("Region");

    var skillVendorStatusCheckboxFieldValue = this.getFieldValue("SkillVendorStatusCheckbox");



    //checkboxes
    //Adaptor
    var adaptorAdaptorExperienceFieldValue = this.getFieldValue("AdaptorAdaptorExperience");
    var adaptorDubbingDirectorExperienceFieldValue = this.getFieldValue("AdaptorDubbingDirectorExperience");
    var adaptorTranslatorExperienceFieldValue = this.getFieldValue("AdaptorTranslatorExperience");
    var adaptorVoiceActorExperienceFieldValue = this.getFieldValue("AdaptorVoiceActorExperience");
    var adaptorTheatricalExperienceFieldValue = this.getFieldValue("AdaptorTheatricalExperience");
    var adaptorTVExperienceFieldValue = this.getFieldValue("AdaptorTVExperience");
    var adaptorGamesExperienceFieldValue = this.getFieldValue("AdaptorGamesExperience");
    var adaptorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("AdaptorPromoOrCommercialsExperience");
    var adaptorLiveActionExperienceFieldValue = this.getFieldValue("AdaptorLiveActionExperience");
    var adaptorAnimationExperienceFieldValue = this.getFieldValue("AdaptorAnimationExperience");
    var adaptorAudioDescriptionExperienceFieldValue = this.getFieldValue("AdaptorAudioDescriptionExperience");
    var adaptorNumberOfAdaptionsFieldValue = this.getFieldValue("AdaptorNumberOfAdaptionsRange");
    var adaptorUniversityDegreeFieldValue = this.getFieldValue("AdaptorUniversityDegree");
    var adaptorSchoolsFieldValue = this.getFieldValue("AdaptorSchools");
    var adaptorStudiosFieldValue = this.getFieldValue("AdaptorStudios");
    var adaptorClientsFieldValue = this.getFieldValue("AdaptorClients");
    var adaptorDoNotUseFieldValue = this.getFieldValue("AdaptorDoNotUse");

    //booker
    var bookerTheatricalExperienceFieldValue = this.getFieldValue("BookerTheatricalExperience");
    var bookerTVExperienceFieldValue = this.getFieldValue("BookerTVExperience");
    var bookerInteractiveExperienceFieldValue = this.getFieldValue("BookerInteractiveExperience");
    var bookerSchoolsFieldValue = this.getFieldValue("BookerSchools");
    var bookerStudiosFieldValue = this.getFieldValue("BookerStudios");
    var bookerClientsFieldValue = this.getFieldValue("BookerClients");
    var bookerDoNotUseFieldValue = this.getFieldValue("BookerDoNotUse");

    //Director
    var directorDubbingDirectorExperienceFieldValue = this.getFieldValue("DirectorDubbingDirectorExperience");
    var directorVoiceOverDirectorExperienceFieldValue = this.getFieldValue("DirectorVoiceOverDirectorExperience");
    var directorSongDirectorExperienceFieldValue = this.getFieldValue("DirectorSongDirectorExperience");
    var directorDubbingActorExperienceFieldValue = this.getFieldValue("DirectorDubbingActorExperience");
    var directorStageDirectorExperienceFieldValue = this.getFieldValue("DirectorStageDirectorExperience");
    var directorMovieDirectorExperienceFieldValue = this.getFieldValue("DirectorMovieDirectorExperience");
    var directorTheatricalExperienceFieldValue = this.getFieldValue("DirectorTheatricalExperience");
    var directorTVExperienceFieldValue = this.getFieldValue("DirectorTVExperience");
    var directorGamesExperienceFieldValue = this.getFieldValue("DirectorGamesExperience");
    var directorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("DirectorPromoOrCommercialsExperience");
    var directorLiveActionExperienceFieldValue = this.getFieldValue("DirectorLiveActionExperience");
    var directorAnimationExperienceFieldValue = this.getFieldValue("DirectorAnimationExperience");
    var directorAudioDescriptionExperienceFieldValue = this.getFieldValue("DirectorAudioDescriptionExperience");
    var directorAudioDescriptionExperienceFieldValue = this.getFieldValue("DirectorAudioDescriptionExperience");
    var directorRemoteRecordingCapabilityFieldValue = this.getFieldValue("DirectorRemoteRecordingCapability");
    var directorAppAccessRevokedFieldValue = this.getFieldValue("DirectorAppAccessRevoked");
    var directorSchoolsFieldValue = this.getFieldValue("DirectorSchools");
    var directorStudiosFieldValue = this.getFieldValue("DirectorStudios");
    var directorClientsFieldValue = this.getFieldValue("DirectorClients");
    var directorDoNotUseFieldValue = this.getFieldValue("DirectorDoNotUse");



    //Editor
    var editorRecordingEditingExperienceFieldValue = this.getFieldValue("EditorRecordingEditingExperience");
    var editorDialogueEditingExperienceFieldValue = this.getFieldValue("EditorDialogueEditingExperience");
    var editorMusicAndEffectsExperienceFieldValue = this.getFieldValue("EditorMusicAndEffectsExperience");
    var editorMixEditingExperienceFieldValue = this.getFieldValue("EditorMixEditingExperience");
    var editorPreparingTakesExperienceFieldValue = this.getFieldValue("EditorPreparingTakesExperience");
    var editorDubbingExperienceFieldValue = this.getFieldValue("EditorDubbingExperience");
    var editorVoiceOverExperienceFieldValue = this.getFieldValue("EditorVoiceOverExperience");
    var editorSongsExperienceFieldValue = this.getFieldValue("EditorSongsExperience");
    var editorProToolsExperienceFieldValue = this.getFieldValue("EditorProToolsExperience");
    var editorDolby51ExperienceFieldValue = this.getFieldValue("EditorDolby51Experience");
    var editorAtmosExperienceFieldValue = this.getFieldValue("EditorAtmosExperience");
    var editorFoleyExperienceFieldValue = this.getFieldValue("EditorFoleyExperience");
    var editorAudioDescriptionExperienceFieldValue = this.getFieldValue("EditorAudioDescriptionExperience");
    var editorSchoolsFieldValue = this.getFieldValue("EditorSchools");
    var editorStudiosFieldValue = this.getFieldValue("EditorStudios");
    var editorClientsFieldValue = this.getFieldValue("EditorClients");
    var editorRemoteRecordingCapabilityFieldValue = this.getFieldValue("EditorRemoteRecordingCapability");
    var editorDoNotUseFieldValue = this.getFieldValue("EditorDoNotUse");


    //lyricist
    var lyricistExperienceFieldValue = this.getFieldValue("LyricistExperience");
    var lyricistDubbingExperienceFieldValue = this.getFieldValue("LyricistDubbingExperience");
    var lyricistMusicianExperienceFieldValue = this.getFieldValue("LyricistMusicianExperience");
    var lyricistNumberOfSongsWrittenFieldValue = this.getFieldValue("LyricistNumberOfSongsWritten");
    var lyricistRemoteRecordingCapabilityFieldValue = this.getFieldValue("LyricistRemoteRecordingCapability");
    var lyricistMusicalExperienceFieldValue = this.getFieldValue("LyricistMusicalExperience");
    var lyricistTheatreExperienceFieldValue = this.getFieldValue("LyricistTheatreExperience");
    var lyricistPromoOrCommercialsExperienceFieldValue = this.getFieldValue("LyricistPromoOrCommercialsExperience");
    var lyricistUniversityDegreeFieldValue = this.getFieldValue("LyricistUniversityDegree");
    var lyricistSchoolsFieldValue = this.getFieldValue("LyricistSchools");
    var lyricistStudiosFieldValue = this.getFieldValue("LyricistStudios");
    var lyricistClientsFieldValue = this.getFieldValue("LyricistClients");
    var lyricistDoNotUseFieldValue = this.getFieldValue("LyricistDoNotUse");

    //Singer
    var singerDubbingExperienceFieldValue = this.getFieldValue("SingerDubbingExperience");
    var singerStageExperienceFieldValue = this.getFieldValue("SingerStageExperience");
    var singerTheatreExperienceFieldValue = this.getFieldValue("SingerTheatreExperience");
    var singerTalentShowExperienceFieldValue = this.getFieldValue("SingerTalentShowExperience");
    var singerMaleVoiceGenderFieldValue = this.getFieldValue("SingerMaleVoiceGender");
    var singerFemaleVoiceGenderFieldValue = this.getFieldValue("SingerFemaleVoiceGender");
    var singerVocalRangeFieldValue = this.getFieldValue("SingerVocalRange");
    var singerMusicNotesReadingLevelFieldValue = this.getFieldValue("SingerMusicNotesReadingLevel");
    var singerVoiceAgeRangeFieldValue = this.getFieldValue("SingerVoiceAge");
    var singerSchoolsFieldValue = this.getFieldValue("SingerSchools");
    var singerStudiosFieldValue = this.getFieldValue("SingerStudios");
    var singerClientsFieldValue = this.getFieldValue("SingerClients");
    var singerRemoteRecordingCapabilityFieldValue = this.getFieldValue("SingerRemoteRecordingCapability");
    var singerUnionFieldValue = this.getFieldValue("SingerUnion");
    var singerGenderNeutralVoiceFieldValue = this.getFieldValue("SingerGenderNeutralVoice");
    var singerDoNotUseFieldValue = this.getFieldValue("SingerDoNotUse");


    //SoundEngineer
    var soundEngineerDialogueRecordingExperienceFieldValue = this.getFieldValue("SoundEngineerDialogueRecordingExperience");
    var soundEngineerSongRecordingExperienceFieldValue = this.getFieldValue("SoundEngineerSongRecordingExperience");
    var soundEngineerDialogueMixingExperienceFieldValue = this.getFieldValue("SoundEngineerDialogueMixingExperience");
    var soundEngineerSongMixingExperienceFieldValue = this.getFieldValue("SoundEngineerSongMixingExperience");
    var soundEngineerAudioDescriptionMixingExperienceFieldValue = this.getFieldValue("SoundEngineerAudioDescriptionMixingExperience");
    var soundEngineerRemoteRecordingCapabilityFieldValue = this.getFieldValue("SoundEngineerRemoteRecordingCapability");
    var soundEngineerDubbingExperienceFieldValue = this.getFieldValue("SoundEngineerDubbingExperience");
    var soundEngineerVoiceOverExperienceFieldValue = this.getFieldValue("SoundEngineerVoiceOverExperience");
    var soundEngineerSongsExperienceFieldValue = this.getFieldValue("SoundEngineerSongsExperience");
    var soundEngineerProToolsExperienceFieldValue = this.getFieldValue("SoundEngineerProToolsExperience");
    var soundEngineerDolby51ExperienceFieldValue = this.getFieldValue("SoundEngineerDolby51Experience");
    var soundEngineerAtmosExperienceFieldValue = this.getFieldValue("SoundEngineerAtmosExperience");
    var soundEngineerFoleyExperienceFieldValue = this.getFieldValue("SoundEngineerFoleyExperience");
    var soundEngineerSchoolsFieldValue = this.getFieldValue("SoundEngineerSchools");
    var soundEngineerStudiosFieldValue = this.getFieldValue("SoundEngineerStudios");
    var soundEngineerClientsFieldValue = this.getFieldValue("SoundEngineerClients");
    var soundEngineerDoNotUseFieldValue = this.getFieldValue("SoundEngineerDoNotUse");

    //Translator
    var translatorSubtitlesExperienceFieldValue = this.getFieldValue("TranslatorSubtitlesExperience");
    var translatorDubbingExperienceFieldValue = this.getFieldValue("TranslatorDubbingExperience");
    var translatorVoiceOverExperienceFieldValue = this.getFieldValue("TranslatorVoiceOverExperience");
    var translatorGamingExperienceFieldValue = this.getFieldValue("TranslatorGamingExperience");
    var translatorAudioDescriptionExperienceFieldValue = this.getFieldValue("TranslatorAudioDescriptionExperience");
    var translatorHOHSDHCCEExperienceFieldValue = this.getFieldValue("TranslatorHOHSDHCCExperience");
    var translatorNumberOfTranslationsFieldValue = this.getFieldValue("TranslatorNumberOfTranslations");
    var translatorTheatricalExperienceFieldValue = this.getFieldValue("TranslatorTheatricalExperience");
    var translatorTVExperienceFieldValue = this.getFieldValue("TranslatorTVExperience");
    var translatorGamesExperienceFieldValue = this.getFieldValue("TranslatorGamesExperience");
    var translatorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("TranslatorPromoOrCommercialsExperience");
    var translatorLiveActionExperienceFieldValue = this.getFieldValue("TranslatorLiveActionExperience");
    var translatorAnimationExperienceFieldValue = this.getFieldValue("TranslatorAnimationExperience");
    var translatorUniversityDegreeFieldValue = this.getFieldValue("TranslatorUniversityDegree");
    var translatorSchoolsFieldValue = this.getFieldValue("TranslatorSchools");
    var translatorStudiosFieldValue = this.getFieldValue("TranslatorStudios");
    var translatorClientsFieldValue = this.getFieldValue("TranslatorClients");
    var translatorDoNotUseFieldValue = this.getFieldValue("TranslatorDoNotUse");

    //VoiceActor
    var voiceActorDubbingExperienceFieldValue = this.getFieldValue("VoiceActorDubbingExperience");
    var voiceActorAudiobooksExperienceFieldValue = this.getFieldValue("VoiceActorAudiobooksExperience");
    var voiceActorVoiceOverExperienceFieldValue = this.getFieldValue("VoiceActorVoiceOverExperience");
    var voiceActorRadioExperienceFieldValue = this.getFieldValue("VoiceActorRadioExperience");
    var voiceActorTheatreActorExperienceFieldValue = this.getFieldValue("VoiceActorTheatreActorExperience");
    var voiceActorMovieActorExperienceFieldValue = this.getFieldValue("VoiceActorMovieActorExperience");
    var voiceActorAudioDescriptionExperienceFieldValue = this.getFieldValue("VoiceActorAudioDescriptionExperience");
    var voiceActorTheatricalExperienceFieldValue = this.getFieldValue("VoiceActorTheatricalExperience");
    var voiceActorTVExperienceFieldValue = this.getFieldValue("VoiceActorTVExperience");
    var voiceActorGamesExperienceFieldValue = this.getFieldValue("VoiceActorGamesExperience");
    var voiceActorPromoOrCommercialsExperienceFieldValue = this.getFieldValue("VoiceActorPromoOrCommercialsExperience");
    var voiceActorLiveActionExperienceFieldValue = this.getFieldValue("VoiceActorLiveActionExperience");
    var voiceActorAnimationExperienceFieldValue = this.getFieldValue("VoiceActorAnimationExperience");
    var voiceActorRemoteRecordingCapabilityFieldValue = this.getFieldValue("VoiceActorRemoteRecordingCapability");
    var voiceActorLiveActionMaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorLiveActionMaleVoiceGender");
    var voiceActorLiveActionFemaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorLiveActionFemaleVoiceGender");
    var voiceActorAnimationMaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorAnimationMaleVoiceGender");
    var voiceActorAnimationFemaleVoiceGenderFieldValue = this.getFieldValue("VoiceActorAnimationFemaleVoiceGender");
    var voiceActorSchoolsFieldValue = this.getFieldValue("VoiceActorSchools");
    var voiceActorStudiosFieldValue = this.getFieldValue("VoiceActorStudios");
    var voiceActorClientsFieldValue = this.getFieldValue("VoiceActorClients");
    var voiceActorVoiceAgeRangeFieldValue = this.getFieldValue("VoiceActorVoiceAge");
    var voiceActorVoiceTypeFieldValue = this.getFieldValue("VoiceActorVoiceType");
    var voiceActorLanguageAccentFieldValue = this.getFieldValue("VoiceActorLanguageAccent");
    var voiceActorUnionFieldValue = this.getFieldValue("VoiceActorUnion");
    var voiceActorGenderNeutralVoiceFieldValue = this.getFieldValue("VoiceActorGenderNeutralVoice");
    var voiceActorDoNotUseFieldValue = this.getFieldValue("VoiceActorDoNotUse");


    let data={};
    let items = [];

    if(nativeLanguageFieldValue){
        items.push({"SearchProperty": 9,"Values": [parseInt(nativeLanguageFieldValue)]});
    }
    if(experienceFieldValue){
        let experienceFieldValueArr = experienceFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<experienceFieldValueArr.length;i++){
          newArr.push(parseInt(experienceFieldValueArr[i]));
        }
        items.push({"SearchProperty": 10,"Values": newArr});
    }
    if(skillLevelFieldValue){
        let skillLevelFieldValueArr = skillLevelFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<skillLevelFieldValueArr.length;i++){
          newArr.push(parseInt(skillLevelFieldValueArr[i]));
        }
        items.push({"SearchProperty": 22,"Values": newArr});
    }
    if(ageFromFieldValue || ageToFieldValue){
      if(ageFromFieldValue && ageToFieldValue == '' || ageFromFieldValue && ageToFieldValue == null){
          let ageArr = [];
          for (let step = ageFromFieldValue; step < 101; step++) {
            ageArr.push(parseInt(step));
          }
          items.push({"SearchProperty": 3,"Values": ageArr});
      }
      if(ageFromFieldValue == '' && ageToFieldValue || ageFromFieldValue == null && ageToFieldValue){
          let number = ageToFieldValue;
          let ageArr = [];
          for (let step = 1; step <= number; step++) {
            ageArr.push(parseInt(step));
          }
          items.push({"SearchProperty": 3,"Values": ageArr});
      }
      if(ageFromFieldValue && ageToFieldValue){
          if(parseInt(ageFromFieldValue)>parseInt(ageToFieldValue)){
            //here should be message - age from bigger than age to
          }else{
            let ageArr = [];
            let numberFrom = parseInt(ageFromFieldValue);
            let numberTo = parseInt(ageToFieldValue);

            while (numberFrom <= numberTo) {
                ageArr.push(numberFrom);
                numberFrom++;
            }
            items.push({"SearchProperty": 3,"Values": ageArr});
          }
        }
      }

      if(productionFieldValue){
        if (typeof productionFieldValue === 'string' || productionFieldValue instanceof String){
          if(productionFieldValue.includes(",")){
            let newArr=[];
            let productionFieldValueArr = productionFieldValue.split(",");
            for(let i=0;i<productionFieldValueArr.length;i++){
              newArr.push(parseInt(productionFieldValueArr[i]));
            }
            items.push({"SearchProperty": 17,"Values": newArr})

          }else{
            items.push({"SearchProperty": 17,"Values": [parseInt(productionFieldValue)]});
          }

        }
        if( productionFieldValue instanceof Array && productionFieldValue.length > 0){
          let newArr=[];
          for(let i=0;i<productionFieldValue.length;i++){
            newArr.push(productionFieldValue[i].value);
          }
          items.push({"SearchProperty": 17,"Values": newArr});
        }
      }

      if(vacancyFieldValue){
        if (typeof vacancyFieldValue === 'string' || vacancyFieldValue instanceof String){
          if(vacancyFieldValue.includes(",")){
            let newArr=[];
            let vacancyFieldValueArr = vacancyFieldValue.split(",");
            for(let i=0;i<vacancyFieldValueArr.length;i++){
              newArr.push(parseInt(vacancyFieldValueArr[i]));
            }
            items.push({"SearchProperty": 18,"Values": newArr})

          }else{
            items.push({"SearchProperty": 18,"Values": [parseInt(vacancyFieldValue)]});
          }

        }
        if( vacancyFieldValue instanceof Array && vacancyFieldValue.length > 0){
          let newArr=[];
          for(let i=0;i<vacancyFieldValue.length;i++){
            newArr.push(vacancyFieldValue[i].value);
          }
          items.push({"SearchProperty": 18,"Values": newArr});
        }
      }

      if(externalExperienceFieldValue){
        if (typeof externalExperienceFieldValue === 'string' || externalExperienceFieldValue instanceof String){
          if(externalExperienceFieldValue.includes(",")){
            let newArr=[];
            let externalExperienceFieldValueArr = externalExperienceFieldValue.split(",");
            for(let i=0;i<externalExperienceFieldValueArr.length;i++){
              newArr.push(parseInt(externalExperienceFieldValueArr[i]));
            }
            items.push({"SearchProperty": 19,"Values": newArr})

          }else{
            items.push({"SearchProperty": 19,"Values": [parseInt(externalExperienceFieldValue)]});
          }

        }
        if( externalExperienceFieldValue instanceof Array && externalExperienceFieldValue.length > 0){
          let newArr=[];
          for(let i=0;i<externalExperienceFieldValue.length;i++){
            newArr.push(externalExperienceFieldValue[i].value);
          }
          items.push({"SearchProperty": 19,"Values": newArr});
        }
      }




    if(skillTypeFieldValue){
        let skillTypeFieldValueArr = skillTypeFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<skillTypeFieldValueArr.length;i++){
          newArr.push(parseInt(skillTypeFieldValueArr[i]));
        }
        items.push({"SearchProperty": 20,"Values": newArr});
    }

    if(directorSchoolsFieldValue){
      if (typeof directorSchoolsFieldValue === 'string' || directorSchoolsFieldValue instanceof String){
        if(directorSchoolsFieldValue.includes(",")){
          let newArr=[];
          let directorSchoolsFieldValueArr = directorSchoolsFieldValue.split(",");
          for(let i=0;i<directorSchoolsFieldValueArr.length;i++){
            newArr.push(parseInt(directorSchoolsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2218,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2218,"Values": [parseInt(directorSchoolsFieldValue)]});
        }

      }
      if( directorSchoolsFieldValue instanceof Array && directorSchoolsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<directorSchoolsFieldValue.length;i++){
          newArr.push(directorSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2218,"Values": newArr});
      }
    }


    if(editorSchoolsFieldValue){
      if (typeof editorSchoolsFieldValue === 'string' || editorSchoolsFieldValue instanceof String){
        if(editorSchoolsFieldValue.includes(",")){
          let newArr=[];
          let editorSchoolsFieldValueArr = editorSchoolsFieldValue.split(",");
          for(let i=0;i<editorSchoolsFieldValueArr.length;i++){
            newArr.push(parseInt(editorSchoolsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2317,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2317,"Values": [parseInt(editorSchoolsFieldValue)]});
        }

      }
      if( editorSchoolsFieldValue instanceof Array && editorSchoolsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<editorSchoolsFieldValue.length;i++){
          newArr.push(editorSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2317,"Values": newArr});
      }
    }
    if(singerSchoolsFieldValue){
      if (typeof singerSchoolsFieldValue === 'string' || singerSchoolsFieldValue instanceof String){
        if(singerSchoolsFieldValue.includes(",")){
          let newArr=[];
          let singerSchoolsFieldValueArr = singerSchoolsFieldValue.split(",");
          for(let i=0;i<singerSchoolsFieldValueArr.length;i++){
            newArr.push(parseInt(singerSchoolsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2515,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2515,"Values": [parseInt(singerSchoolsFieldValue)]});
        }

      }
      if( singerSchoolsFieldValue instanceof Array && singerSchoolsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<singerSchoolsFieldValue.length;i++){
          newArr.push(singerSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2515,"Values": newArr});
      }
    }

    if(soundEngineerSchoolsFieldValue){
      if (typeof soundEngineerSchoolsFieldValue === 'string' || soundEngineerSchoolsFieldValue instanceof String){
        if(soundEngineerSchoolsFieldValue.includes(",")){
          let newArr=[];
          let soundEngineerSchoolsFieldValueArr = soundEngineerSchoolsFieldValue.split(",");
          for(let i=0;i<soundEngineerSchoolsFieldValueArr.length;i++){
            newArr.push(parseInt(soundEngineerSchoolsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2616,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2616,"Values": [parseInt(soundEngineerSchoolsFieldValue)]});
        }

      }
      if( soundEngineerSchoolsFieldValue instanceof Array && soundEngineerSchoolsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<soundEngineerSchoolsFieldValue.length;i++){
          newArr.push(soundEngineerSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2616,"Values": newArr});
      }
    }

    if(voiceActorSchoolsFieldValue){
      if (typeof voiceActorSchoolsFieldValue === 'string' || voiceActorSchoolsFieldValue instanceof String){
        if(voiceActorSchoolsFieldValue.includes(",")){
          let newArr=[];
          let voiceActorSchoolsFieldValueArr = voiceActorSchoolsFieldValue.split(",");
          for(let i=0;i<voiceActorSchoolsFieldValueArr.length;i++){
            newArr.push(parseInt(voiceActorSchoolsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2826,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2826,"Values": [parseInt(voiceActorSchoolsFieldValue)]});
        }

      }
      if( voiceActorSchoolsFieldValue instanceof Array && voiceActorSchoolsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<voiceActorSchoolsFieldValue.length;i++){
          newArr.push(voiceActorSchoolsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2826,"Values": newArr});
      }
    }


    if(this.directorSchools.length>0){
        items.push({"SearchProperty": 2218,"Values": this.directorSchools});
    }
    if(this.editorSchools.length>0){
        items.push({"SearchProperty": 2317,"Values": this.editorSchools});
    }
    if(this.singerSchools.length>0){
        items.push({"SearchProperty": 2515,"Values": this.singerSchools});
    }
    if(this.soundEngineerSchools.length>0){
        items.push({"SearchProperty": 2616,"Values": this.soundEngineerSchools});
    }
    if(this.voiceActorSchools.length>0){
        items.push({"SearchProperty": 2826,"Values": this.voiceActorSchools});
    }



    if(cityFieldValue){
        let cityFieldValueArr = cityFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<cityFieldValueArr.length;i++){
          newArr.push(parseInt(cityFieldValueArr[i]));
        }
        items.push({"SearchProperty": 7,"Values": newArr});
    }
    if(countryFieldValue){
        let countryFieldValueArr = countryFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<countryFieldValueArr.length;i++){
          newArr.push(parseInt(countryFieldValueArr[i]));
        }
        items.push({"SearchProperty": 6,"Values": newArr});
    }
    if(ethnicityFieldValue){
        let ethnicityFieldValueArr = ethnicityFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<ethnicityFieldValueArr.length;i++){
          newArr.push(parseInt(ethnicityFieldValueArr[i]));
        }
        items.push({"SearchProperty": 13,"Values": newArr});
    }
    if(regionFieldValue){
         let regionFieldValueArr = regionFieldValue.split(",");
         let newArr=[];
         for(let i=0;i<regionFieldValueArr.length;i++){
           newArr.push(parseInt(regionFieldValueArr[i]));
         }
         items.push({"SearchProperty": 16,"Values": newArr});
     }
    if(identityFieldValue){
        let identityFieldValueArr = identityFieldValue.split(",");
        let newArr=[];
        for(let i=0;i<identityFieldValueArr.length;i++){
          newArr.push(parseInt(identityFieldValueArr[i]));
        }
        items.push({"SearchProperty": 14,"Values": newArr});
    }
    if(knownTalentFieldValue){
        items.push({"SearchProperty": 24,"Values": [parseInt(1)]});
    }

    if(skillVendorStatusCheckboxFieldValue){
      items.push({"SearchProperty": 5,"Values": [parseInt(0)]});
    }else{
      items.push({"SearchProperty": 5,"Values": [parseInt(10)]});
    }
    /*console.log(skillVendorStatusFieldValue);
    if(skillVendorStatusFieldValue == true){
          items.push({"SearchProperty": 5,"Values": [parseInt(0)]});
    }
    if(skillVendorStatusFieldValue == false || skillVendorStatusFieldValue == ''){
          items.push({"SearchProperty": 5,"Values": [parseInt(10)]});
    }*/
    if(doNotUseFieldValue){
        items.push({"SearchProperty": 4,"Values": [parseInt(1)]});
    }

    if(adaptorDoNotUseFieldValue){
      items.push({"SearchProperty": 2017,"Values": [parseInt(1)]});
    }

    if(adaptorAdaptorExperienceFieldValue){
      items.push({"SearchProperty": 2001,"Values": [parseInt(1)]});
    }
    if(adaptorDubbingDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2002,"Values": [parseInt(1)]});
    }
    if(adaptorTranslatorExperienceFieldValue){
      items.push({"SearchProperty": 2003,"Values": [parseInt(1)]});
    }
    if(adaptorVoiceActorExperienceFieldValue){
      items.push({"SearchProperty": 2004,"Values": [parseInt(1)]});
    }
    if(adaptorTheatricalExperienceFieldValue){
      items.push({"SearchProperty": 2005,"Values": [parseInt(1)]});
    }
    if(adaptorTVExperienceFieldValue){
      items.push({"SearchProperty": 2006,"Values": [parseInt(1)]});
    }
    if(adaptorGamesExperienceFieldValue){
      items.push({"SearchProperty": 2007,"Values": [parseInt(1)]});
    }
    if(adaptorPromoOrCommercialsExperienceFieldValue){
      items.push({"SearchProperty": 2008,"Values": [parseInt(1)]});
    }
    if(adaptorLiveActionExperienceFieldValue){
      items.push({"SearchProperty": 2009,"Values": [parseInt(1)]});
    }
    if(adaptorAnimationExperienceFieldValue){
      items.push({"SearchProperty": 2010,"Values": [parseInt(1)]});
    }
    if(adaptorAudioDescriptionExperienceFieldValue){
      items.push({"SearchProperty": 2011,"Values": [parseInt(1)]});
    }
    if(adaptorNumberOfAdaptionsFieldValue){
      let adaptorNumberOfAdaptionsFieldValueArr = adaptorNumberOfAdaptionsFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<adaptorNumberOfAdaptionsFieldValueArr.length;i++){
        newArr.push(parseInt(adaptorNumberOfAdaptionsFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2012,"Values": newArr});
    }
    if(adaptorUniversityDegreeFieldValue){
      let adaptorUniversityDegreeFieldValueArr = adaptorUniversityDegreeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<adaptorUniversityDegreeFieldValueArr.length;i++){
        newArr.push(parseInt(adaptorUniversityDegreeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2013,"Values": newArr});
    }
    if(adaptorStudiosFieldValue){
      if (typeof adaptorStudiosFieldValue === 'string' || adaptorStudiosFieldValue instanceof String){
        if(adaptorStudiosFieldValue.includes(",")){
          let newArr=[];
          let adaptorStudiosFieldValueArr = adaptorStudiosFieldValue.split(",");
          for(let i=0;i<adaptorStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(adaptorStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2014,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2014,"Values": [parseInt(adaptorStudiosFieldValue)]});
        }

      }
      if( adaptorStudiosFieldValue instanceof Array && adaptorStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<adaptorStudiosFieldValue.length;i++){
          newArr.push(adaptorStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2014,"Values": newArr});
      }
    }

    if(adaptorClientsFieldValue){
      if (typeof adaptorClientsFieldValue === 'string' || adaptorClientsFieldValue instanceof String){
        if(adaptorStudiosFieldValue.includes(",")){
          let newArr=[];
          let adaptorClientsFieldValueArr = adaptorClientsFieldValue.split(",");
          for(let i=0;i<adaptorClientsFieldValueArr.length;i++){
            newArr.push(parseInt(adaptorClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2015,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2015,"Values": [parseInt(adaptorClientsFieldValue)]});
        }

      }
      if( adaptorClientsFieldValue instanceof Array && adaptorClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<adaptorClientsFieldValue.length;i++){
          newArr.push(adaptorClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2015,"Values": newArr});
      }
    }


    if(bookerDoNotUseFieldValue){
      items.push({"SearchProperty": 2107,"Values": [parseInt(1)]});
    }
    if(bookerTheatricalExperienceFieldValue){
      items.push({"SearchProperty": 2101,"Values": [parseInt(1)]});
    }
    if(bookerTVExperienceFieldValue){
      items.push({"SearchProperty": 2102,"Values": [parseInt(1)]});
    }
    if(bookerInteractiveExperienceFieldValue){
      items.push({"SearchProperty": 2103,"Values": [parseInt(1)]});
    }
    if(bookerStudiosFieldValue){
      if (typeof bookerStudiosFieldValue === 'string' || bookerStudiosFieldValue instanceof String){
        if(bookerStudiosFieldValue.includes(",")){
          let newArr=[];
          let bookerStudiosFieldValueArr = bookerStudiosFieldValue.split(",");
          for(let i=0;i<bookerStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(bookerStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2104,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2104,"Values": [parseInt(bookerStudiosFieldValue)]});
        }

      }
      if( bookerStudiosFieldValue instanceof Array && bookerStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<bookerStudiosFieldValue.length;i++){
          newArr.push(bookerStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2104,"Values": newArr});
      }
    }

    if(directorDoNotUseFieldValue){
      items.push({"SearchProperty": 2219,"Values": [parseInt(1)]});
    }
    if(directorDubbingDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2201,"Values": [parseInt(1)]});
    }
    if(directorVoiceOverDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2202,"Values": [parseInt(1)]});
    }
    if(directorSongDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2203,"Values": [parseInt(1)]});
    }
    if(directorDubbingActorExperienceFieldValue){
      items.push({"SearchProperty": 2204,"Values": [parseInt(1)]});
    }
    if(directorStageDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2205,"Values": [parseInt(1)]});
    }
    if(directorMovieDirectorExperienceFieldValue){
      items.push({"SearchProperty": 2206,"Values": [parseInt(1)]});
    }
    if(directorTheatricalExperienceFieldValue){
      items.push({"SearchProperty": 2207,"Values": [parseInt(1)]});
    }
    if(directorTVExperienceFieldValue){
      items.push({"SearchProperty": 2208,"Values": [parseInt(1)]});
    }
    if(directorGamesExperienceFieldValue){
      items.push({"SearchProperty": 2209,"Values": [parseInt(1)]});
    }
    if(directorPromoOrCommercialsExperienceFieldValue){
      items.push({"SearchProperty": 2210,"Values": [parseInt(1)]});
    }
    if(directorLiveActionExperienceFieldValue){
      items.push({"SearchProperty": 2211,"Values": [parseInt(1)]});
    }
    if(directorAnimationExperienceFieldValue){
      items.push({"SearchProperty": 2212,"Values": [parseInt(1)]});
    }
    if(directorAudioDescriptionExperienceFieldValue){
      items.push({"SearchProperty": 2213,"Values": [parseInt(1)]});
    }
    if(directorRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2214,"Values": [parseInt(directorRemoteRecordingCapabilityFieldValue)]});
    }
    if(directorAppAccessRevokedFieldValue === 0){
      items.push({"SearchProperty": 2215,"Values": [parseInt(0)]});
    }
    if(directorAppAccessRevokedFieldValue){
      items.push({"SearchProperty": 2215,"Values": [parseInt(1)]});
    }
    if(directorStudiosFieldValue){
      if (typeof directorStudiosFieldValue === 'string' || directorStudiosFieldValue instanceof String){
        if(directorStudiosFieldValue.includes(",")){
          let newArr=[];
          let directorStudiosFieldValueArr = directorStudiosFieldValue.split(",");
          for(let i=0;i<directorStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(directorStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2216,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2216,"Values": [parseInt(directorStudiosFieldValue)]});
        }

      }
      if( directorStudiosFieldValue instanceof Array && directorStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<directorStudiosFieldValue.length;i++){
          newArr.push(directorStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2216,"Values": newArr});
      }
    }

    if(directorClientsFieldValue){
      if (typeof directorClientsFieldValue === 'string' || directorClientsFieldValue instanceof String){
        if(directorClientsFieldValue.includes(",")){
          let newArr=[];
          let directorClientsFieldValueArr = directorClientsFieldValue.split(",");
          for(let i=0;i<directorClientsFieldValueArr.length;i++){
            newArr.push(parseInt(directorClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2217,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2217,"Values": [parseInt(directorClientsFieldValue)]});
        }

      }
      if( directorClientsFieldValue instanceof Array && directorClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<directorClientsFieldValue.length;i++){
          newArr.push(directorClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2217,"Values": newArr});
      }
    }


    if(editorDoNotUseFieldValue){
      items.push({"SearchProperty": 2318,"Values": [parseInt(1)]});
    }
    if(editorRecordingEditingExperienceFieldValue){
      items.push({"SearchProperty": 2301,"Values": [parseInt(1)]});
    }
    if(editorDialogueEditingExperienceFieldValue){
      items.push({"SearchProperty": 2302,"Values": [parseInt(1)]});
    }
    if(editorMusicAndEffectsExperienceFieldValue){
      items.push({"SearchProperty": 2303,"Values": [parseInt(1)]});
    }
    if(editorMixEditingExperienceFieldValue){
      items.push({"SearchProperty": 2304,"Values": [parseInt(1)]});
    }
    if(editorPreparingTakesExperienceFieldValue){
      items.push({"SearchProperty": 2305,"Values": [parseInt(1)]});
    }
    if(editorDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2306,"Values": [parseInt(1)]});
    }
    if(editorVoiceOverExperienceFieldValue){
      items.push({"SearchProperty": 2307,"Values": [parseInt(1)]});
    }
    if(editorSongsExperienceFieldValue){
      items.push({"SearchProperty": 2308,"Values": [parseInt(1)]});
    }
    if(editorProToolsExperienceFieldValue){
      items.push({"SearchProperty": 2309,"Values": [parseInt(1)]});
    }
    if(editorDolby51ExperienceFieldValue){
      items.push({"SearchProperty": 2310,"Values": [parseInt(1)]});
    }
    if(editorAtmosExperienceFieldValue){
      items.push({"SearchProperty": 2311,"Values": [parseInt(1)]});
    }
    if(editorFoleyExperienceFieldValue){
      items.push({"SearchProperty": 2312,"Values": [parseInt(1)]});
    }
    if(editorAudioDescriptionExperienceFieldValue){
      items.push({"SearchProperty": 2313,"Values": [parseInt(1)]});
    }
    if(editorStudiosFieldValue){
      if (typeof editorStudiosFieldValue === 'string' || editorStudiosFieldValue instanceof String){
        if(editorStudiosFieldValue.includes(",")){
          let newArr=[];
          let editorStudiosFieldValueArr = editorStudiosFieldValue.split(",");
          for(let i=0;i<editorStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(editorStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2315,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2315,"Values": [parseInt(editorStudiosFieldValue)]});
        }

      }
      if( editorStudiosFieldValue instanceof Array && editorStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<editorStudiosFieldValue.length;i++){
          newArr.push(editorStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2315,"Values": newArr});
      }
    }

    if(editorClientsFieldValue){
      if (typeof editorClientsFieldValue === 'string' || editorClientsFieldValue instanceof String){
        if(editorClientsFieldValue.includes(",")){
          let newArr=[];
          let editorClientsFieldValueArr = editorClientsFieldValue.split(",");
          for(let i=0;i<editorClientsFieldValueArr.length;i++){
            newArr.push(parseInt(editorClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2316,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2316,"Values": [parseInt(editorClientsFieldValue)]});
        }

      }
      if( editorClientsFieldValue instanceof Array && editorClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<editorClientsFieldValue.length;i++){
          newArr.push(editorClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2316,"Values": newArr});
      }
    }


    if(editorRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2314,"Values": [parseInt(editorRemoteRecordingCapabilityFieldValue)]});
    }
    if(lyricistDoNotUseFieldValue){
      items.push({"SearchProperty": 2413,"Values": [parseInt(1)]});
    }
    if(lyricistExperienceFieldValue){
      items.push({"SearchProperty": 2401,"Values": [parseInt(1)]});
    }
    if(lyricistDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2402,"Values": [parseInt(1)]});
    }
    if(lyricistMusicianExperienceFieldValue){
      items.push({"SearchProperty": 2403,"Values": [parseInt(1)]});
    }
    if(lyricistNumberOfSongsWrittenFieldValue){
      let lyricistNumberOfSongsWrittenFieldValueArr = lyricistNumberOfSongsWrittenFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<lyricistNumberOfSongsWrittenFieldValueArr.length;i++){
        newArr.push(parseInt(lyricistNumberOfSongsWrittenFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2404,"Values": newArr});
    }
    if(lyricistRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2405,"Values": [parseInt(lyricistRemoteRecordingCapabilityFieldValue)]});
    }
    if(lyricistMusicalExperienceFieldValue){
      items.push({"SearchProperty": 2406,"Values": [parseInt(1)]});
    }
    if(lyricistTheatreExperienceFieldValue){
      items.push({"SearchProperty": 2407,"Values": [parseInt(1)]});
    }
    if(lyricistPromoOrCommercialsExperienceFieldValue){
      items.push({"SearchProperty": 2408,"Values": [parseInt(1)]});
    }
    if(lyricistUniversityDegreeFieldValue){
      let lyricistUniversityDegreeFieldValueArr = lyricistUniversityDegreeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<lyricistUniversityDegreeFieldValueArr.length;i++){
        newArr.push(parseInt(lyricistUniversityDegreeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2409,"Values": newArr});
    }
    if(lyricistStudiosFieldValue){
      if (typeof lyricistStudiosFieldValue === 'string' || lyricistStudiosFieldValue instanceof String){
        if(lyricistStudiosFieldValue.includes(",")){
          let newArr=[];
          let lyricistStudiosFieldValueArr = lyricistStudiosFieldValue.split(",");
          for(let i=0;i<lyricistStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(lyricistStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2410,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2410,"Values": [parseInt(lyricistStudiosFieldValue)]});
        }

      }
      if( lyricistStudiosFieldValue instanceof Array && lyricistStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<lyricistStudiosFieldValue.length;i++){
          newArr.push(lyricistStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2410,"Values": newArr});
      }
    }

    if(lyricistClientsFieldValue){
      if (typeof lyricistClientsFieldValue === 'string' || lyricistClientsFieldValue instanceof String){
        if(lyricistStudiosFieldValue.includes(",")){
          let newArr=[];
          let lyricistClientsFieldValueArr = lyricistClientsFieldValue.split(",");
          for(let i=0;i<lyricistClientsFieldValueArr.length;i++){
            newArr.push(parseInt(lyricistClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2411,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2411,"Values": [parseInt(lyricistClientsFieldValue)]});
        }

      }
      if( lyricistClientsFieldValue instanceof Array && lyricistClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<lyricistClientsFieldValue.length;i++){
          newArr.push(lyricistClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2411,"Values": newArr});
      }
    }


    if(singerDoNotUseFieldValue){
      items.push({"SearchProperty": 2516,"Values": [parseInt(1)]});
    }
    if(singerDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2501,"Values": [parseInt(1)]});
    }
    if(singerStageExperienceFieldValue){
      items.push({"SearchProperty": 2502,"Values": [parseInt(1)]});
    }
    if(singerTheatreExperienceFieldValue){
      items.push({"SearchProperty": 2503,"Values": [parseInt(1)]});
    }
    if(singerTalentShowExperienceFieldValue){
      items.push({"SearchProperty": 2505,"Values": [parseInt(1)]});
    }
    if(singerMaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2509,"Values": [parseInt(1)]});
    }
    if(singerFemaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2510,"Values": [parseInt(1)]});
    }
    if(singerGenderNeutralVoiceFieldValue){
      items.push({"SearchProperty": 2514,"Values": [parseInt(1)]});
    }
    if(singerVocalRangeFieldValue){
      let singerVocalRangeFieldValueArr = singerVocalRangeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<singerVocalRangeFieldValueArr.length;i++){
        newArr.push(parseInt(singerVocalRangeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2506,"Values": newArr});
    }
    if(singerMusicNotesReadingLevelFieldValue){
      let singerMusicNotesReadingLevelFieldValueArr = singerMusicNotesReadingLevelFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<singerMusicNotesReadingLevelFieldValueArr.length;i++){
        newArr.push(parseInt(singerMusicNotesReadingLevelFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2507,"Values": newArr});
    }
    if(singerVoiceAgeRangeFieldValue){
      let singerVoiceAgeRangeFieldValueArr = singerVoiceAgeRangeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<singerVoiceAgeRangeFieldValueArr.length;i++){
        newArr.push(parseInt(singerVoiceAgeRangeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2508,"Values": newArr});
    }
    if(singerStudiosFieldValue){
      if (typeof singerStudiosFieldValue === 'string' || singerStudiosFieldValue instanceof String){
        if(singerStudiosFieldValue.includes(",")){
          let newArr=[];
          let singerStudiosFieldValueArr = singerStudiosFieldValue.split(",");
          for(let i=0;i<singerStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(singerStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2511,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2511,"Values": [parseInt(singerStudiosFieldValue)]});
        }

      }
      if( singerStudiosFieldValue instanceof Array && singerStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<singerStudiosFieldValue.length;i++){
          newArr.push(singerStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2511,"Values": newArr});
      }
    }

    if(singerClientsFieldValue){
      if (typeof singerClientsFieldValue === 'string' || singerClientsFieldValue instanceof String){
        if(singerClientsFieldValue.includes(",")){
          let newArr=[];
          let singerClientsFieldValueArr = singerClientsFieldValue.split(",");
          for(let i=0;i<singerClientsFieldValueArr.length;i++){
            newArr.push(parseInt(singerClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2512,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2512,"Values": [parseInt(singerClientsFieldValue)]});
        }

      }
      if( singerClientsFieldValue instanceof Array && singerClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<singerClientsFieldValue.length;i++){
          newArr.push(singerClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2512,"Values": newArr});
      }
    }


    if(singerRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2504,"Values": [parseInt(singerRemoteRecordingCapabilityFieldValue)]});
    }
    if(singerUnionFieldValue){
      let singerUnionFieldValueArr = singerUnionFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<singerUnionFieldValueArr.length;i++){
        newArr.push(parseInt(singerUnionFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2513,"Values": newArr});
    }
    if(soundEngineerDoNotUseFieldValue){
      items.push({"SearchProperty": 2617,"Values": [parseInt(1)]});
    }
    if(soundEngineerDialogueRecordingExperienceFieldValue){
      items.push({"SearchProperty": 2601,"Values": [parseInt(1)]});
    }
    if(soundEngineerSongRecordingExperienceFieldValue){
      items.push({"SearchProperty": 2602,"Values": [parseInt(1)]});
    }
    if(soundEngineerDialogueMixingExperienceFieldValue){
      items.push({"SearchProperty": 2603,"Values": [parseInt(1)]});
    }
    if(soundEngineerSongMixingExperienceFieldValue){
      items.push({"SearchProperty": 2604,"Values": [parseInt(1)]});
    }
    if(soundEngineerAudioDescriptionMixingExperienceFieldValue){
      items.push({"SearchProperty": 2605,"Values": [parseInt(1)]});
    }
    if(soundEngineerRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2606,"Values": [parseInt(soundEngineerRemoteRecordingCapabilityFieldValue)]});
    }
    if(soundEngineerDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2607,"Values": [parseInt(1)]});
    }
    if(soundEngineerVoiceOverExperienceFieldValue){
      items.push({"SearchProperty": 2608,"Values": [parseInt(1)]});
    }
    if(soundEngineerSongsExperienceFieldValue){
      items.push({"SearchProperty": 2609,"Values": [parseInt(1)]});
    }
    if(soundEngineerProToolsExperienceFieldValue){
      items.push({"SearchProperty": 2610,"Values": [parseInt(1)]});
    }
    if(soundEngineerDolby51ExperienceFieldValue){
      items.push({"SearchProperty": 2611,"Values": [parseInt(1)]});
    }
    if(soundEngineerAtmosExperienceFieldValue){
      items.push({"SearchProperty": 2612,"Values": [parseInt(1)]});
    }
    if(soundEngineerFoleyExperienceFieldValue){
      items.push({"SearchProperty": 2613,"Values": [parseInt(1)]});
    }
    if(soundEngineerStudiosFieldValue){
      if (typeof soundEngineerStudiosFieldValue === 'string' || soundEngineerStudiosFieldValue instanceof String){
        if(soundEngineerStudiosFieldValue.includes(",")){
          let newArr=[];
          let soundEngineerStudiosFieldValueArr = soundEngineerStudiosFieldValue.split(",");
          for(let i=0;i<soundEngineerStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(soundEngineerStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2614,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2614,"Values": [parseInt(soundEngineerStudiosFieldValue)]});
        }

      }
      if( soundEngineerStudiosFieldValue instanceof Array && soundEngineerStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<soundEngineerStudiosFieldValue.length;i++){
          newArr.push(soundEngineerStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2614,"Values": newArr});
      }
    }

    if(soundEngineerClientsFieldValue){
      if (typeof soundEngineerClientsFieldValue === 'string' || soundEngineerClientsFieldValue instanceof String){
        if(soundEngineerClientsFieldValue.includes(",")){
          let newArr=[];
          let soundEngineerClientsFieldValueArr = soundEngineerClientsFieldValue.split(",");
          for(let i=0;i<soundEngineerClientsFieldValueArr.length;i++){
            newArr.push(parseInt(soundEngineerClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2615,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2615,"Values": [parseInt(soundEngineerClientsFieldValue)]});
        }

      }
      if( soundEngineerClientsFieldValue instanceof Array && soundEngineerClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<soundEngineerClientsFieldValue.length;i++){
          newArr.push(soundEngineerClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2615,"Values": newArr});
      }
    }

    if(translatorDoNotUseFieldValue){
      items.push({"SearchProperty": 2719,"Values": [parseInt(1)]});
    }
    if(translatorSubtitlesExperienceFieldValue){
      items.push({"SearchProperty": 2701,"Values": [parseInt(1)]});
    }
    if(translatorDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2702,"Values": [parseInt(1)]});
    }
    if(translatorVoiceOverExperienceFieldValue){
      items.push({"SearchProperty": 2703,"Values": [parseInt(1)]});
    }
    if(translatorGamingExperienceFieldValue){
      items.push({"SearchProperty": 2704,"Values": [parseInt(1)]});
    }
    if(translatorAudioDescriptionExperienceFieldValue){
      items.push({"SearchProperty": 2705,"Values": [parseInt(1)]});
    }
    if(translatorHOHSDHCCEExperienceFieldValue){
      items.push({"SearchProperty": 2706,"Values": [parseInt(1)]});
    }
    if(translatorNumberOfTranslationsFieldValue){
      let translatorNumberOfTranslationsFieldValueArr = translatorNumberOfTranslationsFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<translatorNumberOfTranslationsFieldValueArr.length;i++){
        newArr.push(parseInt(translatorNumberOfTranslationsFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2708,"Values": newArr});
    }
    if(translatorTheatricalExperienceFieldValue){
      items.push({"SearchProperty": 2709,"Values": [parseInt(1)]});
    }
    if(translatorTVExperienceFieldValue){
      items.push({"SearchProperty": 2710,"Values": [parseInt(1)]});
    }
    if(translatorGamesExperienceFieldValue){
      items.push({"SearchProperty": 2711,"Values": [parseInt(1)]});
    }
    if(translatorPromoOrCommercialsExperienceFieldValue){
      items.push({"SearchProperty": 2712,"Values": [parseInt(1)]});
    }
    if(translatorLiveActionExperienceFieldValue){
      items.push({"SearchProperty": 2713,"Values": [parseInt(1)]});
    }
    if(translatorAnimationExperienceFieldValue){
      items.push({"SearchProperty": 2714,"Values": [parseInt(1)]});
    }
    if(translatorUniversityDegreeFieldValue){
      let translatorUniversityDegreeFieldValueArr = translatorUniversityDegreeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<translatorUniversityDegreeFieldValueArr.length;i++){
        newArr.push(parseInt(translatorUniversityDegreeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2715,"Values": newArr});
    }
    if(translatorStudiosFieldValue){
      if (typeof translatorStudiosFieldValue === 'string' || translatorStudiosFieldValue instanceof String){
        if(translatorStudiosFieldValue.includes(",")){
          let newArr=[];
          let translatorStudiosFieldValueArr = translatorStudiosFieldValue.split(",");
          for(let i=0;i<translatorStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(translatorStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2716,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2716,"Values": [parseInt(translatorStudiosFieldValue)]});
        }

      }
      if( translatorStudiosFieldValue instanceof Array && translatorStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<translatorStudiosFieldValue.length;i++){
          newArr.push(translatorStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2716,"Values": newArr});
      }
    }

    if(translatorClientsFieldValue){
      if (typeof translatorClientsFieldValue === 'string' || translatorClientsFieldValue instanceof String){
        if(translatorClientsFieldValue.includes(",")){
          let newArr=[];
          let translatorClientsFieldValueArr = translatorClientsFieldValue.split(",");
          for(let i=0;i<translatorClientsFieldValueArr.length;i++){
            newArr.push(parseInt(translatorClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2717,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2717,"Values": [parseInt(translatorClientsFieldValue)]});
        }

      }
      if( translatorClientsFieldValue instanceof Array && translatorClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<translatorClientsFieldValue.length;i++){
          newArr.push(translatorClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2717,"Values": newArr});
      }
    }


    if(voiceActorDoNotUseFieldValue){
      items.push({"SearchProperty": 2827,"Values": [parseInt(1)]});
    }
    if(voiceActorDubbingExperienceFieldValue){
      items.push({"SearchProperty": 2801,"Values": [parseInt(1)]});
    }
    if(voiceActorAudiobooksExperienceFieldValue){
      items.push({"SearchProperty": 2802,"Values": [parseInt(1)]});
    }
    if(voiceActorVoiceOverExperienceFieldValue){
      items.push({"SearchProperty": 2803,"Values": [parseInt(1)]});
    }
    if(voiceActorRadioExperienceFieldValue){
      items.push({"SearchProperty": 2804,"Values": [parseInt(1)]});
    }
    if(voiceActorTheatreActorExperienceFieldValue){
      items.push({"SearchProperty": 2805,"Values": [parseInt(1)]});
    }
    if(voiceActorMovieActorExperienceFieldValue){
      items.push({"SearchProperty": 2806,"Values": [parseInt(1)]});
    }
    if(voiceActorAudioDescriptionExperienceFieldValue){
      items.push({"SearchProperty": 2807,"Values": [parseInt(1)]});
    }
    if(voiceActorTheatricalExperienceFieldValue){
      items.push({"SearchProperty": 2808,"Values": [parseInt(1)]});
    }
    if(voiceActorTVExperienceFieldValue){
      items.push({"SearchProperty": 2809,"Values": [parseInt(1)]});
    }
    if(voiceActorGamesExperienceFieldValue){
      items.push({"SearchProperty": 2810,"Values": [parseInt(1)]});
    }
    if(voiceActorPromoOrCommercialsExperienceFieldValue){
      items.push({"SearchProperty": 2811,"Values": [parseInt(1)]});
    }
    if(voiceActorLiveActionExperienceFieldValue){
      items.push({"SearchProperty": 2812,"Values": [parseInt(1)]});
    }
    if(voiceActorAnimationExperienceFieldValue){
      items.push({"SearchProperty": 2813,"Values": [parseInt(1)]});
    }
    if(voiceActorRemoteRecordingCapabilityFieldValue){
      items.push({"SearchProperty": 2814,"Values": [parseInt(voiceActorRemoteRecordingCapabilityFieldValue)]});
    }
    if(voiceActorLiveActionMaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2815,"Values": [parseInt(1)]});
    }
    if(voiceActorLiveActionFemaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2816,"Values": [parseInt(1)]});
    }
    if(voiceActorAnimationMaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2817,"Values": [parseInt(1)]});
    }
    if(voiceActorAnimationFemaleVoiceGenderFieldValue){
      items.push({"SearchProperty": 2818,"Values": [parseInt(1)]});
    }
    if(voiceActorGenderNeutralVoiceFieldValue){
      items.push({"SearchProperty": 2825,"Values": [parseInt(1)]});
    }
    if(voiceActorStudiosFieldValue){
      if (typeof voiceActorStudiosFieldValue === 'string' || voiceActorStudiosFieldValue instanceof String){
        if(voiceActorStudiosFieldValue.includes(",")){
          let newArr=[];
          let voiceActorStudiosFieldValueArr = voiceActorStudiosFieldValue.split(",");
          for(let i=0;i<voiceActorStudiosFieldValueArr.length;i++){
            newArr.push(parseInt(voiceActorStudiosFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2819,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2819,"Values": [parseInt(voiceActorStudiosFieldValue)]});
        }

      }
      if( voiceActorStudiosFieldValue instanceof Array && voiceActorStudiosFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<voiceActorStudiosFieldValue.length;i++){
          newArr.push(voiceActorStudiosFieldValue[i].value);
        }
        items.push({"SearchProperty": 2819,"Values": newArr});
      }
    }

    if(voiceActorClientsFieldValue){
      if (typeof voiceActorClientsFieldValue === 'string' || voiceActorClientsFieldValue instanceof String){
        if(voiceActorClientsFieldValue.includes(",")){
          let newArr=[];
          let voiceActorClientsFieldValueArr = voiceActorClientsFieldValue.split(",");
          for(let i=0;i<voiceActorClientsFieldValueArr.length;i++){
            newArr.push(parseInt(voiceActorClientsFieldValueArr[i]));
          }
          items.push({"SearchProperty": 2820,"Values": newArr})

        }else{
          items.push({"SearchProperty": 2820,"Values": [parseInt(voiceActorClientsFieldValue)]});
        }

      }
      if( voiceActorClientsFieldValue instanceof Array && voiceActorClientsFieldValue.length > 0){
        let newArr=[];
        for(let i=0;i<voiceActorClientsFieldValue.length;i++){
          newArr.push(voiceActorClientsFieldValue[i].value);
        }
        items.push({"SearchProperty": 2820,"Values": newArr});
      }
    }


    if(voiceActorVoiceAgeRangeFieldValue){
      let voiceActorVoiceAgeRangeFieldValueArr = voiceActorVoiceAgeRangeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<voiceActorVoiceAgeRangeFieldValueArr.length;i++){
        newArr.push(parseInt(voiceActorVoiceAgeRangeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2821,"Values": newArr});
    }
    if(voiceActorVoiceTypeFieldValue){
      let voiceActorVoiceTypeFieldValueArr = voiceActorVoiceTypeFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<voiceActorVoiceTypeFieldValueArr.length;i++){
        newArr.push(parseInt(voiceActorVoiceTypeFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2823,"Values": newArr});
    }
    if(voiceActorLanguageAccentFieldValue){
      let voiceActorLanguageAccentFieldValueArr = voiceActorLanguageAccentFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<voiceActorLanguageAccentFieldValueArr.length;i++){
        newArr.push(parseInt(voiceActorLanguageAccentFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2822,"Values": newArr});
    }
    if(voiceActorUnionFieldValue){
      let voiceActorUnionFieldValueArr = voiceActorUnionFieldValue.split(",");
      let newArr=[];
      for(let i=0;i<voiceActorUnionFieldValueArr.length;i++){
        newArr.push(parseInt(voiceActorUnionFieldValueArr[i]));
      }
      items.push({"SearchProperty": 2824,"Values": newArr});
    }



    let url = 'skillVendorsSearch';


    this.setState({
      itemsForFilter:items,
      fullTextSearchForFilter:searchTextValue
    });


    //check if list has selected at least one filter
    if(this.state.selectedFilterListName){
      this.setState({
        isListSelected: true
      });
    }

    data = {
      "FullTextSearch": searchTextValue?searchTextValue:'',
      "Items": items
    }

    console.log(data);
    //save items to state related to SaveFilterOption
    this.setState({checkedFilters:items});

    //counters section-------------

    //personalCounter
    let personalCounterArr = [];
    data.Items.map((element) =>{
      if(element.SearchProperty <25 && element.SearchProperty !== 17 && element.SearchProperty !== 18 && element.SearchProperty !== 19 && element.SearchProperty !== 22 && element.SearchProperty !== 20){
        if(element.SearchProperty == 5 && element.Values[0] ==10 ){
        }else{
          personalCounterArr.push(element.SearchProperty);
        }
      }
    });
    this.setState({personalCounter: personalCounterArr.length});

    this.setState({directorCounter: this.countSelectedFilters(data.Items, '22')});
    this.setState({translatorCounter: this.countSelectedFilters(data.Items, '27')});
    this.setState({adaptorCounter: this.countSelectedFilters(data.Items, '20')});
    this.setState({lyricistCounter: this.countSelectedFilters(data.Items, '24')});
    this.setState({actorCounter: this.countSelectedFilters(data.Items, '28')});
    this.setState({singerCounter: this.countSelectedFilters(data.Items, '25')});
    this.setState({editorCounter: this.countSelectedFilters(data.Items, '23')});
    this.setState({soundEngineerCounter: this.countSelectedFilters(data.Items, '26')});
    this.setState({bookerCounter: this.countSelectedFilters(data.Items, '21')});

    //castCounter
    let castCounterArr = [];
    data.Items.map((element) =>{
      let str = element.SearchProperty.toString();
      if(str.substring(0,2) == '17' || str.substring(0,2) == '18' || str.substring(0,2) == '19'){
          castCounterArr.push(element.SearchProperty);
      }
    });
    this.setState({castCounter: castCounterArr.length});
    //end counter section--------------

    this.setState({dataSearch: data})
    this.props.ajax.post(
        url,
      JSON.stringify(data),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if(response){
          if(response.length){
            response.forEach((el, index) => {
              return (response[index].NavigationParam = response[index].Id);
            });
            this.setState({
              items: response
            });
          }
          else{
            this.setState({items: []});
          }
        }
      }, true)

      //reset schools arr
      this.directorSchools = [];
      this.editorSchools = [];
      this.singerSchools = [];
      this.soundEngineerSchools = [];
      this.voiceActorSchools = [];
  }

  exportSkillVendors() {
    let urlExport = "skillvendors/export";
    if (this.state.items.length < 1) {
      alert("No matching records found.");
      return;
    }

    this.props.ajax.post(
        urlExport,
      JSON.stringify(this.state.dataSearch),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if(response){
          if(response){
            takeExcelFile(response);
          }
          else{
            this.setState({items: []});
          }
        }
      })
  }

  getFieldValue(fieldName) {
    var field = this.props.skillVendorSearchFields.find((el) => {
      return el.name === fieldName;
    });
    return field.value;
  }

  inputSearch(e){
    this.setState({inputSearch: e.target.value});
    if(this.timeout) clearTimeout(this.timeout);
     this.timeout = setTimeout(() => {
       this.onSearch();
     }, 1000);
   }

  // search onEnter
  handleKeyDown (e){
    if(e.key == 'Enter'){
      this.onSearch()
    }
  }

  onClear(){
    this.setState({inputSearch: ''});

    // if(this.timeout) clearTimeout(this.timeout);
    //  this.timeout = setTimeout(() => {
    //    this.props.clearSkillVendorSearchFields();
    //    this.onClearFields();
    //    this.onSearch();
    //  }, 1000);
  }

  //call method from child
  onClearFields = () => {}

  clearFieldFn = (newMethod) => {
    this.onClearFields = newMethod;
  }
  //end

  handleMouseEnter(){
    this.setState({showSaveTalentOptions:true});
  }

  handleMouseLeave(){
    this.setState({showSaveTalentOptions:false});
  }


  getListsFromSkillVendorSearch(){
   let url = 'skillVendors/searchpage';
   this.props.ajax.get(url, true, (data) => {

     var ageFromList = {Items: [], SelectedValue: this.state.ageFromSelectedValue};
     for (var i = 1; i < 101; i++){
       ageFromList.Items.push({ value: i.toString(), label: i.toString() });
     }

     //age to list
     var ageToList = {Items: [], SelectedValue: this.state.ageToSelectedValue};
     for (var i = 1; i < 101; i++){
       ageToList.Items.push({ value: i, label: i.toString() });
     }

     //nativeLanguage new object
     var nativeLanguageList = {Items: [], SelectedValue: this.state.nativeLanguageSelectedValue};
     var nativeLanguageObj = data.NativeLanguages.Items;
     for (var i = 0; i < nativeLanguageObj.length; i++){
       nativeLanguageList.Items.push({ value:nativeLanguageObj[i].id , label:nativeLanguageObj[i].label  });
     }

     //experience new object
     var experienceList = {Items: [], SelectedValue: this.state.additionalLanguagesSelectedValue};
     var experienceObj = data.Experiences.Items;
     for (var i = 0; i < experienceObj.length; i++){
       experienceList.Items.push({ value:experienceObj[i].id , label:experienceObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingList = {Items: [], SelectedValue: ''};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingList.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     var remoteRecordingDirector = {Items: [], SelectedValue: this.state.remoteRecordingDirectorSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingDirector.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //lyricist remoteRecording new object
     var remoteRecordingListLyricist = {Items: [], SelectedValue: this.state.remoteRecordingLyricistSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListLyricist.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingListVoiceActor = {Items: [], SelectedValue: this.state.remoteRecordingListVoiceActorSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListVoiceActor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //singer remoteRecording new object
     var remoteRecordingListSinger = {Items: [], SelectedValue: this.state.remoteRecordingSingerSelectedValue};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListSinger.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingEditor = {Items: [], SelectedValue: this.state.editorRemoteRecordingCapability};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingEditor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //remoteRecording new object
     var remoteRecordingListSoundEngineer = {Items: [], SelectedValue: this.state.soundEngineerRemoteRecordingCapability};
     var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
     for (var i = 0; i < remoteRecordingObj.length; i++){
       remoteRecordingListSoundEngineer.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
     }

     //numberOfAdaptionsRange new object
     var numberOfAdaptionsRangeList = {Items: [], SelectedValue: this.state.adaptorNumberOfAdaptionsRange};
     var numberOfAdaptionsRangeObj = data.NumberOfAdaptionsRanges.Items;
     for (var i = 0; i < numberOfAdaptionsRangeObj.length; i++){
       numberOfAdaptionsRangeList.Items.push({ value:numberOfAdaptionsRangeObj[i].id , label:numberOfAdaptionsRangeObj[i].label  });
     }

     //numberOfSongsWrittenRange new object
     var numberOfSongsWrittenRangeList = {Items: [], SelectedValue: this.state.lyricistNumberOfSongsWritten};
     var numberOfSongsWrittenRangeObj = data.NumberOfSongsWrittenRanges.Items;
     for (var i = 0; i < numberOfSongsWrittenRangeObj.length; i++){
       numberOfSongsWrittenRangeList.Items.push({ value:numberOfSongsWrittenRangeObj[i].id , label:numberOfSongsWrittenRangeObj[i].label  });
     }

     //numberOfTranslationsRange new object
     var numberOfTranslationsRangeList = {Items: [], SelectedValue: this.state.translatorNumberOfTranslations};
     var numberOfTranslationsRangeObj = data.NumberOfTranslationsRanges.Items;
     for (var i = 0; i < numberOfTranslationsRangeObj.length; i++){
       numberOfTranslationsRangeList.Items.push({ value:numberOfTranslationsRangeObj[i].id , label:numberOfTranslationsRangeObj[i].label  });
     }

     //skillLevel new object
     var skillLevelList = {Items: [], SelectedValue: this.state.skillLevelSelectedValue};
     var skillLevelObj = data.SkillLevels.Items;
     for (var i = 0; i < skillLevelObj.length; i++){
       skillLevelList.Items.push({ value:skillLevelObj[i].id , label:skillLevelObj[i].label  });
     }

     //gender new object
     var genderList = {Items: [], SelectedValue: ''};
     var genderObj = data.Genders.Items;
     for (var i = 0; i < genderObj.length; i++){
       genderList.Items.push({ value:genderObj[i].id , label:genderObj[i].label  });
     }

     //city new object
     // var cityList = {Items: [], SelectedValue: this.state.citySelectedValue}
     var cityList = {Items: [], SelectedValue: this.state.citySelectedValue};
     var cityObj = data.Cities.Items;
     for (var i = 0; i < cityObj.length; i++){
       cityList.Items.push({ value:cityObj[i].id , label:cityObj[i].label  });
     }


     //skillType new object
     var skillTypeList = {Items: [], SelectedValue: this.state.skillTypeSelectedValue};
     var skillTypeObj = data.SkillTypes.Items;
     for (var i = 0; i < skillTypeObj.length; i++){
       if(skillTypeObj[i].id == 0){
         var idsArr = [];
         for (var j = 0; j < skillTypeObj[i].Children.length; j++){
           idsArr.push(skillTypeObj[i].Children[j].id)
         }
         skillTypeList.Items.push({ value:idsArr , label:skillTypeObj[i].label  });
       }else{
           skillTypeList.Items.push({ value:skillTypeObj[i].id , label:skillTypeObj[i].label});
       }
     }


     //school new object
     var schoolList = {Items: [], SelectedValue: this.state.voiceActorSchool};

     var schoolObj = data.Schools.Items;
     for (var i = 0; i < schoolObj.length; i++){
       schoolList.Items.push({ value:schoolObj[i].id , label:schoolObj[i].label  });
     }

     //skillVendorStatus new object
     var statusList = {Items: [], SelectedValue: ''};
     var statusObj = data.SkillVendorStatuses.Items;
     for (var i = 0; i < statusObj.length; i++){
       statusList.Items.push({ value:statusObj[i].id , label:statusObj[i].label  });
     }

     //UniversityDegree new object translator
     var universityDegreeList = {Items: [], SelectedValue: this.state.translatorUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeList.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //adaptor UniversityDegree new object
     var universityDegreeListAdaptor = {Items: [], SelectedValue: this.state.adaptorUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeListAdaptor.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //lyricist UniversityDegree new object
     var universityDegreeListLyricist = {Items: [], SelectedValue: this.state.lyricistUniversityDegree};
     var universityDegreeObj = data.UniversityDegrees.Items;
     for (var i = 0; i < universityDegreeObj.length; i++){
       universityDegreeListLyricist.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
     }

     //VocalRange new object singer
     var vocalRangeList = {Items: [], SelectedValue: this.state.vocalRangeSingerSelectedValue};
     var vocalRangeObj = data.VocalRanges.Items;
     for (var i = 0; i < vocalRangeObj.length; i++){
       vocalRangeList.Items.push({ value:vocalRangeObj[i].id , label:vocalRangeObj[i].label  });
     }

     //MusicNotesReadingLevel new object singer
     var musicNotesReadingLevelList = {Items: [], SelectedValue: this.state.readingMusicNoteSingerSelectedValue};
     var musicNotesReadingLevelObj = data.MusicNotesReadingLevels.Items;
     for (var i = 0; i < musicNotesReadingLevelObj.length; i++){
       musicNotesReadingLevelList.Items.push({ value:musicNotesReadingLevelObj[i].id , label:musicNotesReadingLevelObj[i].label  });
     }

     //VoiceAgeRange new object
     var voiceAgeRangeList = {Items: [], SelectedValue: this.state.voiceAgeSelectedValue};
     var oiceAgeRangeObj = data.VoiceAgeRanges.Items;
     for (var i = 0; i < oiceAgeRangeObj.length; i++){
       voiceAgeRangeList.Items.push({ value:oiceAgeRangeObj[i].id , label:oiceAgeRangeObj[i].label  });
     }

     // singer VoiceAgeRange new object
     var voiceAgeRangeListSinger = {Items: [], SelectedValue: this.state.voiceAgeSingerSelectedValue};
     var voiceAgeRangeObj = data.VoiceAgeRanges.Items;
     for (var i = 0; i < voiceAgeRangeObj.length; i++){
       voiceAgeRangeListSinger.Items.push({ value:voiceAgeRangeObj[i].id , label:voiceAgeRangeObj[i].label  });
     }

     //country new object
     var countryList = {Items: [], SelectedValue: this.state.countrySelectedValue};
     var countryObj = data.CountriesOfLiving.Items;
     for (var i = 0; i < countryObj.length; i++){
       countryList.Items.push({ value:countryObj[i].id , label:countryObj[i].label  });
     }

     //ethnicity new object
     var ethnicityList = {Items: [], SelectedValue: this.state.ethnicitySelectedValue};
     if(data.Ethnicities.Items.length>0){
       this.setState({isEthnicity: true});
       var ethnicityObj = data.Ethnicities.Items;
       for (var i = 0; i < ethnicityObj.length; i++){
         ethnicityList.Items.push({ value:ethnicityObj[i].id , label:ethnicityObj[i].label  });
       }
     }

     //identity new object
     var identityList = {Items: [], SelectedValue: this.state.identitySelectedValue};
     if(data.Identities.Items.length>0){
       this.setState({isIdentity: true});
       var identityObj = data.Identities.Items;
       for (var i = 0; i < identityObj.length; i++){
         identityList.Items.push({ value:identityObj[i].id , label:identityObj[i].label  });
       }
     }

     //voiceType new object
     var voiceTypeList = {Items: [], SelectedValue: this.state.voiceTypeSelectedValue};
     var voiceTypeObj = data.VoiceTypes.Items;
     for (var i = 0; i < voiceTypeObj.length; i++){
       voiceTypeList.Items.push({ value:voiceTypeObj[i].id , label:voiceTypeObj[i].label  });
     }

     //languageAccent new object
     var languageAccentList = {Items: [], SelectedValue: this.state.languageAccent};
     if(data.LanguageAccents.Items.length>0){
       this.setState({isAccent: true});
       var languageAccentObj = data.LanguageAccents.Items;
       for (var i = 0; i < languageAccentObj.length; i++){
         languageAccentList.Items.push({ value:languageAccentObj[i].id , label:languageAccentObj[i].label  });
       }
     }

     //union new object voiceActor
     var unionList = {Items: [], SelectedValue: this.state.voiceActorUnionSelectedValue};
     if(data.Unions.Items.length>0){
       this.setState({isUnion: true});
       var unionObj = data.Unions.Items;
       for (var i = 0; i < unionObj.length; i++){
         unionList.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
       }
     }

     //union new object singer
     var unionListSinger = {Items: [], SelectedValue: this.state.singerUnionSelectedValue};
     if(data.Unions.Items.length>0){
       var unionObj = data.Unions.Items;
       for (var i = 0; i < unionObj.length; i++){
         unionListSinger.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
       }
       this.setState({isSingerUnion: true});
     }

     //region new object
     var regionList = {Items: [], SelectedValue: this.state.regionSelectedValue};
     if(data.Regions.Items.length>0){
       this.setState({isRegions: true});
       var regionObj = data.Regions.Items;
       for (var i = 0; i < regionObj.length; i++){
         regionList.Items.push({ value:regionObj[i].id , label:regionObj[i].label  });
       }
     }

     this.props.setSkillVendorSearchDropdownOptions(
        skillTypeList,
        skillLevelList,
        ageFromList,
        ageToList,
        cityList,
        schoolList,
        nativeLanguageList,
        experienceList,
        remoteRecordingList,
        genderList,
        statusList,
        numberOfAdaptionsRangeList,
        numberOfSongsWrittenRangeList,
        numberOfTranslationsRangeList,
        universityDegreeList,
        vocalRangeList,
        musicNotesReadingLevelList,
        voiceAgeRangeList,
        countryList,
        ethnicityList,
        identityList,
        voiceTypeList,
        languageAccentList,
        unionList,
        regionList,
        remoteRecordingDirector,
        remoteRecordingListLyricist,
        remoteRecordingListVoiceActor,
        remoteRecordingListSinger,
        remoteRecordingEditor,
        remoteRecordingListSoundEngineer,
        universityDegreeListAdaptor,
        universityDegreeListLyricist,
        voiceAgeRangeListSinger,
        unionListSinger
      );
   });
 }

 //callback method for set fullTextSearchForFilter
 getFullTextSearchForFilter(val){
   this.setState({inputSearch:val});
 }

 getFilterListName(val){
   this.setState({selectedFilterListName:val});
 }

 getFilterListId(val){
   if(val){
      this.setState({isListSelected: true});
   }
 }

 removeSelectedPresetFilter(){
   this.setState({
     isListSelected:false,
     selectedFilterListName:''
   });
 }

  render() {
    return (
      <div>

      { this.state.showSaveTalentOptions &&
        <div className="nav-item nav-item-dropdown" onMouseLeave={this.handleMouseLeave.bind(this)}>
          <div className="navbar-dropdown"
          style={{position:"absolute", marginLeft:"65%",marginTop:"3%" , zIndex:"99", cursor:"pointer", backgroundColor:"white"}}

          >
            <div className="dropdown-inner filter-preset">
                
                  <div  className="dropdown-item" style={{coursor:"pointer"}} onClick={() => this.cleanSearchForm()}>
                      <span>Clean search form </span>
                  </div>
                <div  className="dropdown-item" style={{coursor:"pointer"}} onClick={() => this.loadFilterList()}>
                    <span>Load filter preset</span>
                </div>
                <div  className="dropdown-item" style={{coursor:"pointer"}} onClick={() => this.saveAsFilterList()}>
                    <span>Save filter preset as</span>
                </div>
                {this.state.isListSelected &&
                  <div  className="dropdown-item" style={{coursor:"pointer"}} onClick={() => this.updateFilterList()}>
                      <span>Save <i>"{this.state.selectedFilterListName}"</i></span>
                  </div>
                }
                {this.state.isListSelected &&
                  <div  className="dropdown-item" style={{coursor:"pointer"}} onClick={() => this.removeFilterList()}>
                      <span>Remove <i>"{this.state.selectedFilterListName}"</i></span>
                  </div>
                }
            </div>
          </div>
        </div>
      }
        <div className="row">
          <div className="col-10">
            <div className="input-group" style={{width:"95%"}}>
              <input ref={this.textInput} value={this.state.inputSearch || ''} type="text" name="inputSearch" className="form-control grid-search-input form-control-sm mb-3" placeholder="Search by name, email, phone or produb number..." onChange={this.inputSearch} onKeyDown={this.handleKeyDown.bind(this)}/>
              <span className="input-group-addon grid-search-icon"><i className="fa fa-search"></i></span>
            </div>
          </div>
          <div className="col-2" style={{marginTop:"14px"}}>
            <span
              style={{verticalAlign:"bottom", cursor:"pointer", marginLeft:"-30%"}}
              onMouseEnter={this.handleMouseEnter.bind(this)}
            >
              <i className="sli-options-vertical"></i>
            </span>
          </div>
        </div>
        <div>

        </div>
        <div className="row">
          <div className="col-3" style={{overflow: "auto", maxHeight:"850px", fontSize: "0.8rem"}}>
            <SkillVendorSearch inputSearch={this.state.inputSearch}
             clearInputSearch={this.onClear.bind(this)}
             removeSelectedPresetFilter={this.removeSelectedPresetFilter.bind(this)}
             onSearch={this.onSearch} clear={this.clearFieldFn}
             personalCounter={this.state.personalCounter}
             directorCounter={this.state.directorCounter}
             translatorCounter={this.state.translatorCounter}
             adaptorCounter={this.state.adaptorCounter}
             lyricistCounter={this.state.lyricistCounter}
             actorCounter={this.state.actorCounter}
             singerCounter={this.state.singerCounter}
             editorCounter={this.state.editorCounter}
             soundEngineerCounter={this.state.soundEngineerCounter}
             bookerCounter={this.state.bookerCounter}
             castCounter={this.state.castCounter}
             showSaveTalentOptions={this.state.showSaveTalentOptions}
             itemsForFilter={this.state.itemsForFilter}
             fullTextSearchForFilter={this.state.fullTextSearchForFilter}
             setClickLoadFilterList={e => this.loadFilterList = e}
             setClickSaveAsFilterList={e => this.saveAsFilterList = e}
             setClickremoveFilterList={e => this.removeFilterList = e}
             setClickupdateFilterList={e => this.updateFilterList = e}
             setClickCleanSearchForm={e => this.cleanSearchForm = e}
             //callback method for set fullTextSearchForFilter and filterList name
             sendFullTextSearchForFilter={this.getFullTextSearchForFilter.bind(this)}
             sendFilterListName={this.getFilterListName.bind(this)}
             sendFilterListId={this.getFilterListId.bind(this)}



            />
          </div>
          <div className="col-9">
            <SkillVendorList items={this.state.items} />
            <div className="mt-3">
              <button className="btn btn-primary btn-rounded mr-2" disabled={this.state.items.length>0 ? "" : "disabled"} type="button" onClick={this.exportSkillVendors}>
                Export
              </button>

              {this.state.items.length > 0 && <NewAdminMessageButton skillVendorIds={this.state.items.map((m) => m.Id)} recipients={`Talents > Search (${this.state.items.length})`} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorSearchFields: state.skillVendorSearch.fields,
});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
  clearSkillVendorSearchFields() { dispatch(clearSkillVendorSearchFields()) }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(SkillVendorSearchAndList));
